(function () {
  'use strict';

  d3.chart('ChartBase').extend('AreaLineChart', {
    initialize : function (options) {
      var plot = this;

      options = options || {};

      var margin = {
        top: 20,
        right: 40,
        bottom: 40,
        left: 60
      };

      plot.padding(margin);

      _.defaultsDeep(options, {
        width : 1000,
        height : 180,
        xAxis : false,
        yAxis : true,
        xFormat : null,
        yFormat : null,
        showGrid : true,
        drawAreaChart: false,
        baseTick: false,
        tooltipRowHeight: 35,
        tooltipDefaultXPos: 10,
        tooltipDefaultYPos: -20,
        tooltipXPadding: 15
      });


      plot.x = d3.time.scale();

      plot.y = d3.scale.linear();

      // allows for having a fixed y-range (e.g. always starting at 0).
      plot.yDomain = options.yDomain || {};

      plot.axisSvgs = {
        x : plot.wrap.append('g').classed('chart-axis x', true),
        y : plot.wrap.append('g').classed('chart-axis y', true)
      };

      plot.axes = {
        x : d3.svg.axis().scale(plot.x).orient('bottom'),
        y : d3.svg.axis().scale(plot.y).orient('left')
      };


      plot.axisLabels = {
        y: plot.wrap.append('g').classed('y-label', true)
      };

      plot.axisLabels.y
          .append("text")
          .attr("class", "y-label-text")
          .attr("transform", "rotate(-90)")
          .attr("y", -margin.left)
          .attr("dy", "1em")
          .text(options.yAxisLabel);

      if (!options.xAxis) {
        plot.axisSvgs.x.style('display', 'none');
      }

      if (!options.yAxis) {
        plot.axisSvgs.y.style('display', 'none');
      }

      if(options.xAxisTicks){
        plot.axes.x.ticks(options.xAxisTicks.ticks, options.xAxisTicks.tickInterval || null);
      }
      // allows to format x axis
      if (options.xFormat) {
        plot.axes.x.tickFormat(options.xFormat);
      }

      // allows to format y axis
      if (options.yFormat) {
        plot.axes.y.tickFormat(options.yFormat);
      }

      if(options.tickValues){
        plot.axes.y.tickValues(options.tickValues);
      }

      plot.layers = {
        charts: plot.wrap.append("g").classed("charts", true),
        lonePoints: plot.wrap.append("g").classed("lonePoints", true),
        focus: plot.wrap.append("g").classed("focus", true).style("display", "none"),
        rect: plot.wrap.append("rect")
            .attr("class", "overlay")
      };

      // Plotting the line chart
      plot.line = d3.svg.line().interpolate('monotone')
          .defined(function (d) { return _.isFinite(d.y); })  //Draw with missing points
          .x(function(d, i) { return plot.x(plot.xLabel.values[i]); })
          .y(function(d) { return plot.y(d.yPos); });

      //Plotting area charts
      plot.area = d3.svg.area().interpolate('monotone')
          .defined(function (d) { return _.isFinite(d.y); })  //Draw with missing points
          .x(function(d, i) { return plot.x(plot.xLabel.values[i]);})
          .y0(function(d) { return plot.y(d.y0); })
          .y1(function(d) { return plot.y(d.yPos); });

      plot.layer('charts', plot.layers.charts, {
        dataBind : function (data) {
          return this.selectAll('.chart')
              .data(plot.data);
        },
        insert : function () {
          var chartLine = this;

          chartLine.append("g")
              .attr("class", "chart")
              .append("path")
              .attr("class", (options.drawAreaChart) ? "area" : "line");

          return chartLine;
        },
        events : {
          merge: function () {
            var that = this;
            that.select("path")
                .attr("d", function(d) {
                  return (options.drawAreaChart) ? plot.area(d.values) : plot.line(d.values);
                })
                .style("fill", function(d) {
                  return options.drawAreaChart ? d.color.fill : "none";
                })
                .style("fill-opacity", function(d) {
                  return options.drawAreaChart ? d.color.opacity : "none";
                })
                .style("stroke", function(d) {
                  return d.color.stroke;
                });
          },
          exit : function () {
            this.remove();
          }
        }
      });

      plot.layer('lonePoints', plot.layers.lonePoints, {
        dataBind : function (data) {
          var lonePoints = _.flatMap(plot.data, function (chartData) {
            return _(chartData.values)
                .map( function (value, index) {
                  return { x: index, y: value.yPos, color: chartData.color.stroke };
                })
                .filter( function (value, index) {
                  // If the current value is not null and it has both the adjacent data points as null or beyond the
                  // array bounds, we should plot a single point.
                  return value.y !== null
                      && (index - 1 < 0 || chartData.values[index - 1].yPos === null)
                      && (index + 1 >= chartData.values.length || chartData.values[index + 1].yPos === null);
                })
                .value();
          });

          return this.selectAll('.lonePoint')
              .data(lonePoints);
        },
        insert : function () {
          var chartLine = this;

          chartLine
              .append("g")
              .attr("class", "lonePoint")
              .append("circle").classed('line-per-circle', true)
              .attr("r", 3.5)
              .attr("stroke-width", 2);

          return chartLine;
        },
        events : {
          merge: function () {
            var that = this;
            that.select("circle")
                .attr("cx", function (d) {
                  return plot.x(plot.xLabel.values[d.x]);
                })
                .attr("cy", function (d) {
                  return plot.y(d.y);
                })
                .attr("stroke", function (d) {
                  return d.color;
                })

          },
          exit : function () {
            this.remove();
          }
        }
      });

      plot.layer('focus', plot.layers.focus, {
        dataBind : function (data) {
          return this.selectAll('.focus')
              .data([1]);
        },
        insert : function () {

          var focus = this;

          // Making sure only one focus svg is created
          if(!this[0].parentNode.hasChildNodes()) {
            var numberOfLines = plot.data.length;
            var rowHeight = options.tooltipRowHeight;
            var padding = options.tooltipXPadding;

            var tooltipElem = focus.insert('svg').classed('tooltip-elem', true);

            tooltipElem.append("rect")
                .classed("focus-tooltip", true)
                .attr("height", (numberOfLines + 1) * options.tooltipRowHeight)
                .attr("rx", 4)
                .attr("ry", 4);

            tooltipElem.append("rect")
                .classed("date-rect", true)
                .attr("height", options.tooltipRowHeight)
                .attr("rx", 4)
                .attr("ry", 4);

            tooltipElem.append("text")
                .classed("tooltip-date", true)
                .attr("x", padding)
                .attr("y", (rowHeight / 2));

            _.forEach(plot.data, function(d, i){
              tooltipElem.append("text")
                  .classed("tooltip-label-"+ i, true)
                  .text(d.label)
                  .style("fill", d.labelColor)
                  .attr("x", padding)
                  .attr("y", (rowHeight * (i + 1)) + (rowHeight / 2));

              tooltipElem.append("text")
                  .classed("tooltip-value-"+ i, true)
                  .style("fill", d.labelColor)
                  .attr("y", (rowHeight * (i + 1)) + (rowHeight / 2));
            });

            focus.insert("g")
                .attr("class", "hover-line")
                .append("line")
                .attr("y1", 0);

            focus.insert('g').classed('circle', true);
          }

          return focus;
        },
        events : {
          merge: function () {
            var that = this;

            if(that.classed('circle')){
              _.forEach(plot.data, function(d, i){
                that.append("circle").classed('line-per-circle', true)
                    .attr("r", 3)
                    .attr("stroke", d.color.stroke)
                    .attr("stroke-width", 2);
              });
            }
          },
          exit : function () {
            this.remove();
          }
        }
      });

      function formatDate(d){
        return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
      }

      function mousemove() {
        var bisect = d3.bisector(function (d) { return d; }).left;
        var xLabels = plot.xLabel.values;
        var mouse = d3.mouse(this)[0],
            xMousePos = plot.x.invert(mouse),
            idx = bisect(xLabels, xMousePos, 1),
            i = (xMousePos - xLabels[idx]) > (xLabels[idx - 1] - xMousePos) ? idx : idx - 1,
            x0 = xLabels[i],
            y = d3.max(_.map(plot.data, function(d) { return d.values[i] && d.values[i].yPos; })),
            elem = plot.layers.focus.select('.tooltip-elem');
        if(_.isFinite(y)){
          plot.layers.focus.selectAll('.line-per-circle')
              .attr("transform", function (d, x) {
                return "translate(" + plot.x(x0) + "," + plot.y(plot.data[x].values[i].yPos) + ")";
              });
          plot.layers.focus.select('.hover-line line')
              .attr("x1", plot.x(x0)).attr("x2", plot.x(x0));

          plot.layers.focus.style("display", null);
          updateContent(elem);
          positionTooltip(plot.x(x0), plot.y(y));
        }

        function updateContent(elem){
          elem.select(".tooltip-date").text(options.prependXLabelText(plot.xLabel.label(x0)));
          _.forEach(plot.data, function(v, k){
            var yValue = v.values[i].y;
            if (plot.options.drawAreaChart && v.stackedTotal){
              yValue = v.values[i].yPos;
            }
            elem.select(".tooltip-value-" + k).text(_.isNull(yValue) ? '-.-' : options.formatYLabelText(yValue));
          });

          //get max widths of all elements
          var maxElemWidths = getMaxElemWidths();
          var labelValueMaxWidth = maxElemWidths.maxLabelWidth + maxElemWidths.maxValueWidth + options.tooltipXPadding;
          var tooltipWidth = _.max([labelValueMaxWidth, maxElemWidths.date]) + (options.tooltipXPadding * 2);

          //set the x attr for tooltip value to right align it
          _.forEach(plot.data, function (v, k) {
            elem.select(".tooltip-value-" + k).attr("x", tooltipWidth - maxElemWidths.maxValueWidth - options.tooltipXPadding);
          });

          //set the width calculated above to avoid overflows
          elem.select(".focus-tooltip").style("width", tooltipWidth);
          elem.select(".date-rect").style("width", tooltipWidth);
        }

        function getMaxElemWidths() {
          var tooltipElem = plot.layers.focus;
          var dateWidth = getDimension(tooltipElem.select('.tooltip-date'), "width");
          var labelValueWidth = _.map(plot.data, function(d, i) {
            return ['label', 'value'].reduce(function (acc, currentValue) {
              var elem = ".tooltip-"+ currentValue + "-" + i;
              acc[currentValue] = getDimension(tooltipElem.select(elem), "width");
              return acc;
            },{});
          });
          return {
            'maxLabelWidth': _.maxBy(labelValueWidth, 'label').label,
            'maxValueWidth': _.maxBy(labelValueWidth, 'value').value,
            'date': dateWidth
          }

        }

        function getDimension(elem, dim){
          return elem.node().getBBox()[dim];
        }

        function positionTooltip(currentXPosition, currentYPosition){
          var xPosFunc = function (dimension) {
            //mirror tooltip over y-axis if the tooltip gets clipped
            return currentXPosition - dimension - options.tooltipDefaultXPos;
          };
          var yPosFunc = function (dimension) {
            //move tooltip up by the value required to bring tooltip in the charts area
            return currentYPosition + (plot.h + margin.bottom - Math.ceil(currentYPosition + dimension))
          };

          var newXPos = getUpdatedPosition("width", plot.w, currentXPosition, options.tooltipDefaultXPos, xPosFunc);
          var newYPos = getUpdatedPosition("height", plot.h + margin.bottom, currentYPosition, options.tooltipDefaultYPos, yPosFunc);
          updateTooltipPosition(newXPos, newYPos);
        }

        function getUpdatedPosition(dim, totalDim, currPos, initialPos, posFunc) {
          var focus = plot.layers.focus;
          var focusTooltip = focus.select('.focus-tooltip');
          var dimension = getDimension(focusTooltip, dim);

          if(totalDim <= Math.ceil(currPos + dimension + initialPos)){ //if the tooltip overflows at right or bottom
            return posFunc(dimension);
          } else {
            return currPos + initialPos;
          }
        }

        function updateTooltipPosition(xPos, yPos) {
          var tooltipElem = plot.layers.focus.select('.tooltip-elem');
          tooltipElem.attr("x", xPos)
              .attr("y", yPos);
        }

      }

      function calcRange() {

        plot.x.range([0, plot.w]);
        plot.y.range([plot.h, 0]);

        if(plot.w > 0 && plot.h > 0) {
          plot.layers.rect
              .attr("width", plot.w)
              .attr("height", plot.h);
        }

        plot.layers.focus.select('.hover-line line').attr("y2", plot.h);

        if (options.showGrid) {
          plot.axes.y.tickPadding(10).innerTickSize(-plot.w);
        }

        plot.axisSvgs.x
            .translate(0, plot.y.range()[0])
            .call(plot.axes.x)
            .selectAll('.x .tick text')
            .call(function(t) {
              t.each(function (d) {
                var label = d3.select(this);
                var date = label.text().split(' ');
                label.text(''); // clear the text
                _(date)
                    .reverse()
                    .each(function(v) {
                      label.append("tspan")
                          .attr("x", 0)
                          .attr("dy", "1em")
                          .text(v)
                    });
              })
            });

        plot.axisSvgs.y
            .call(plot.axes.y);

        plot.axisLabels.y.select('.y-label-text')
            .attr("x", -plot.h/2);

        if(options.baseTick){
          plot.axisSvgs.y.select('.tick').select('text').style("opacity", 0);
        }

        // Pointer events on graph
        plot.layers.rect
            .on("mouseout", function() {  plot.layers.focus.style("display", "none"); })
            .on("mousemove", mousemove);

        // Transform graph
        d3.select("svg").select("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
      }

      plot.on('change:width', calcRange)
          .on('change:height', calcRange)
          .on('change:data', calcRange);
    },
    transform: function (data) {
      var plot = this;

      if (data !== plot.data) {

        plot.xLabel = data['xData'];

        plot.data = [];

        _(data['yData']).map(function (obj, k){
          var map = {};
          map[k] = obj;
          plot.data.push(obj);
        }).value();

        plot.data.forEach(function(x) { x.values = _.map(x.values, function(val) {return {y: val, yPos: val}}) });

        // TODO refactor AreaLineChart, so that we do not need to check plot.drawAreaChart every time to handle logic
        //  specific to area or line chart
        if(plot.options.drawAreaChart) {
          var stack = d3.layout.stack()
              .values(function (d) { return d.values;});

          stack(plot.data); // This sets the offset for y as 'y0' for each value.

          plot.data.forEach(function(x) { _.forEach(x.values, function(val) {
            return _.extend(val, {yPos: val.y + val.y0});
          }) });
        }

        // Set domain of x axis
        plot.x.domain(d3.extent(plot.xLabel.values, function(d){ return d}));

        // Set domain range of y axis
        plot.y.domain(['min', 'max'].map(function (minOrMax) {
          var setValue = plot.yDomain[minOrMax];
          return !_.isUndefined(setValue) ? setValue :
              d3[minOrMax](_.map(plot.data, function(c){
                return d3[minOrMax](c.values)}
              ));
        })).nice();
      }

      return data;
    }
  });

})();
